// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"2e501fc8","193":"b617526b"}[chunkId] + ".chunk.js";
};